<template>
  <div class="release-arrive">
    <div style="margin-top: -30px">
      <icon-title
        title="编辑推文排序"
        :img-src="require('@/assets/home/admin/home/text_title.png')"
      />
    </div>
    <CustomTable
      :tableData="tableData"
      :tableHeaders="dialogTableHeader"
      :pagination="dialogPagination"
      :isShowPagination="false"
      :loading="dialogTableLoading"
    >
      <template #action="{ row, column, index }">
        <div style="border: 2px solid red">
          <el-button
            v-if="index == 0"
            class="custom-btn none"
            size="small"
            @click="togglePosition(index, 'top')"
            :disabled="tableData.length <= 1"
            >下移</el-button
          >
          <div v-else-if="index === tableData.length - 1">
            <el-button
              class="custom-btn none"
              size="small"
              @click="togglePosition(index, 'top')"
              :disabled="tableData.length <= 1"
              >上移</el-button
            >
          </div>
          <div v-else>
            <el-button
              class="custom-btn none"
              size="small"
              @click="togglePosition(index, 'top')"
              :disabled="tableData.length <= 1"
              >上移</el-button
            >
            <el-button
              class="custom-btn none"
              size="small"
              @click="togglePosition(index, 'bottom')"
              :disabled="tableData.length <= 1"
              >下移</el-button
            >
          </div>
        </div>
      </template>
    </CustomTable>
    <div style="display: flex; margin: 10px">
      <div
        style="
          margin: 10px;
          background-color: #348cf8;
          color: #fff;
          text-align: center;
          width: 100px;
          font-size: 13px;
          border-radius: 5px;
          height: 30px;
          line-height: 30px;
        "
      >
        预览效果图
      </div>
      <div style="display: flex; flex-direction: column; align-items: center">
        <img :src="$serverImgUrl + '100.png'" style="max-height: 500px" />
        <div style="margin-top: 10px">
          <el-button
            class="cancel-btn"
            @click="handleFormCancel"
            style="
              padding: 0 30px;
              height: 30px;
              font-size: 13px;
              border-color: #348cf8;
              color: #348cf8;
              line-height: 30px;
            "
            >取消</el-button
          >
          <el-button
            @click="handlePublishConfirm"
            :loading="publishLoading"
            class="confirm-btn"
            style="
              padding: 0 30px;
              height: 30px;
              font-size: 13px;
              border-color: #348cf8;
              color: #348cf8;
              line-height: 30px;
            "
            >确认</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 引入文章表格的列配置
import {
  articleTableHeaders,
  dialogTableHeaders,
  actionButtons,
} from "@/utils/defaultData";
export default {
  name: "ArticleSort",
  props: {
    tableData: Array,
  },
  data() {
    return {
      publishLoading: false,
      dialogTableHeader: dialogTableHeaders, // 发布弹窗表格列配置
      dialogTableLoading: false,
      dialogPagination: {
        total: 10,
        currentPage: 1,
        pageSize: 10,
      },
    };
  },
  created() {},
  watch: {},
  methods: {
    // 切换位置功能（根据当前位置自动执行上移或下移）
    togglePosition(index, type) {
      if (this.dialogTableData.length <= 1) return;

      const newData = [...this.dialogTableData];

      // 如果是第一行，执行下移
      if (index === 0 || type === "bottom") {
        // 与下一行交换位置
        const temp = newData[index];
        newData[index] = newData[index + 1];
        newData[index + 1] = temp;
        this.dialogTableData = newData;
        this.$message.success(`已将第${index + 1}行下移`);
      }
      // 如果是最后一行，执行上移
      else if (index === this.dialogTableData.length - 1 || type === "top") {
        // 与上一行交换位置
        const temp = newData[index];
        newData[index] = newData[index - 1];
        newData[index - 1] = temp;
        this.dialogTableData = newData;
        this.$message.success(`已将第${index + 1}行上移`);
      }
    },
    // 取消
    handleFormCancel() {
      this.$emit("cancel", null);
    },
    handlePublishConfirm() {
      this.publishLoading = true;
      // 这里调用发布成功接口
      setTimeout(() => {
        this.publishLoading = false;
        this.$emit("confirm", "success");
      }, 1000);
    },
  },
};
</script>
<style scoped lang="scss">
.release-arrive {
  padding: 20px;
}
</style>
